export const MILLISECONDS = {
  SECOND: 1000,
  MINUTE: 60 * 1000,
  HOUR: 60 * 60 * 1000,
  DAY: 24 * 60 * 60 * 1000,

  inMinutes: (minutes: number) => minutes * 60 * 1000,
  inSeconds: (seconds: number) => seconds * 1000,
  inHours: (hours: number) => hours * 60 * 60 * 1000,
  inDays: (days: number) => days * 24 * 60 * 60 * 1000,
} as const;

export const SECONDS = {
  SECOND: 1,
  MINUTE: 60,
  HOUR: 60 * 60,
  DAY: 24 * 60 * 60,

  inMinutes: (minutes: number) => minutes * 60,
  inHours: (hours: number) => hours * 60 * 60,
  inDays: (days: number) => days * 24 * 60 * 60,
} as const;
